import axiosApiInstance from "./settings";
import {IEdge} from "../models/types";

export const EdgesHttp={
    getById: (id:number) => axiosApiInstance.get<IEdge>(`/edges/${id}`).then(res=> res.data).catch(e=> Promise.reject(e))
}